module.exports = __webpack_public_path__ + "static/media/news-seriesb-announcement.36fcc16e.jpg";